import React, { use, useState } from "react";
import {
  Check,
  Tag,
  CreditCard,
  TrendingUp,
  Gift,
  Zap,
  CheckCircle,
  Shield,
  Headphones,
} from "lucide-react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Col, Modal, Row } from "react-bootstrap";
//import './Subscription.scss';
import { useSelector } from "react-redux";
import moment from "moment";
import { hitGetSubscriptionProfessionalApi } from "../../../Redux/Professional/GetSubscriptionProfessionalSlice";
import { hitUpdateSubscriptionProfessionalApi } from "../../../Redux/Professional/UpdateSubscriptionProfessionalSlice";
import redTick from "../../../assets/img/red tick.svg";
import dollar from "../../../assets/img/dollar green.svg";
import cancelIcon from "../../../assets/img/cross cancel.svg";
import greenTick from "../../../assets/img/green tick subs.svg";
import BiddingCost from "../../../assets/img/Bidding Costs.svg";
import EarnFreeCredit from "../../../assets/img/Earn Free Credits.svg";
import tickCard from "../../../assets/img/What You Get tick.svg";
import VerifiedClients from "../../../assets/img/Verified Clients.svg";
import Business from "../../../assets/img/Grow Your Business.svg";
import ExpertSupport from "../../../assets/img/Expert Support.svg";
import WELCOME_TO_SIMPLERENOVATE from "../../../assets/img/WELCOME TO SIMPLERENOVATE.svg";
import Overlay_tick from "../../../assets/img/Overlay_tick.svg";
import pricing1 from "../../../assets/img/pricing 1.svg";
import pricing2 from "../../../assets/img/pricing 2.svg";
import pricing3 from "../../../assets/img/pricing 3.svg";
import pricing4 from "../../../assets/img/pricing 4.svg";
import pricing5 from "../../../assets/img/pricing 5.svg";
import pricing6 from "../../../assets/img/pricing 6.svg";
import pricing7 from "../../../assets/img/pricing 7.svg";
import pricing8 from "../../../assets/img/pricing 8.svg";
import pricing9 from "../../../assets/img/pricing 9.svg";
import activeIcon from "../../../assets/img/active pricing icon.svg";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import GrowYourBusiness from "../../../assets/img/Grow Your Business.svg";
import For_Professionals from "../../../assets/img/For Professionals.svg";
import For_Professionals1 from "../../../assets/img/For Professionals1.svg";
import pricing_icon_profile from "../../../assets/img/pricing_icon_profile.svg";
import Plan from "../../../assets/img/Pro Plan.svg";
import Annual from "../../../assets/img/Pro Plan Annual.svg";
import {
  ApiBaseUrl,
  createStripeSessionSubscriptionProfessional,
  monthlyPlanPriceId,
  stripeKey,
  yearlyPlanPriceId,
} from "../../../Utils/Constants";
import { getProfessionalAuthToken } from "../../../Helper/mobileAuth";
import { loadStripe } from "@stripe/stripe-js";

const BuySubscription = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [upgradePlanData, setUpgradePlanData] = useState(null);
  const [isOnFreePlan, setIsOnFreePlan] = useState(false);

  const [activeSubscriptionId, setActiveSubscriptionId] = useState(null);
  // get last element after slash
  const [token, setToken] = useState(null);

  useEffect(() => {
    const parsedToken = getProfessionalAuthToken();
    if (!parsedToken) {
      const isProWeb = window.location.pathname.startsWith("/professional");
      navigate(isProWeb ? "/professional/login" : "/login", { replace: true });
    } else {
      setToken(parsedToken);
      dispatch(hitGetSubscriptionProfessionalApi(parsedToken));
    }
  }, [dispatch, navigate]);

  const stripePromise = loadStripe(stripeKey);

  const [choosePlanData, setChoosePlanData] = useState(null);

  const [isActiveMonthlyPlan, setIsActiveMonthlyPlan] = useState(false);
  const [isActiveYearlyPlan, setIsActiveYearlyPlan] = useState(false);
  const [showAnnualUpgradeModal, setShowAnnualUpgradeModal] = useState(false);
  const [isUpgradingAnnual, setIsUpgradingAnnual] = useState(false);
  const [annualUpgradeSucceeded, setAnnualUpgradeSucceeded] = useState(false);

  const subscriptionResponseData = useSelector(
    (state) => state.getSubscriptionProfessionalReducer.data,
  );

  useEffect(() => {
    if (subscriptionResponseData && subscriptionResponseData.status === true) {
      setSubscriptionData(subscriptionResponseData.data);
      if (subscriptionResponseData.data !== null) {
        setActiveSubscriptionId(subscriptionResponseData.data.subscriptionDetails.id);
        if (
          subscriptionResponseData.data.subscriptionDetails.plan.interval ===
          "month"
        ) {
          setIsActiveMonthlyPlan(true);
          setUpgradePlanData(upgradePlanDataYearly);
        } else {
          setIsActiveYearlyPlan(true);
          setUpgradePlanData(upgradeToProPlanMonthly);
        }
      } else {
        setIsOnFreePlan(true);
        setUpgradePlanData(upgradeToProPlanMonthly);
      }
    }
  }, [subscriptionResponseData]);

  const handleSubscriptionWhenNoPlan = async (planName) => {
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    let priceId = "";
    if (planName === "Pro Plan Annual") {
      priceId = yearlyPlanPriceId;
    } else if (planName === "Pro Plan Monthly") {
      priceId = monthlyPlanPriceId;
    }

    await stripePromise;

    try {
      const response = await axios.post(
        `${ApiBaseUrl}${createStripeSessionSubscriptionProfessional}`,
        { priceId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data?.status === true && response.data?.data?.url) {
        window.location.href = response.data.data.url;
      } else {
        showToast(
          response.data?.message ||
            response.data?.data?.message ||
            "Unable to start subscription checkout. Please try again.",
          "error"
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        return;
      }
      showToast(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
        "error"
      );
    }
  };

  const handleSubscriptionCancel = (subscriptionId) => {
    if (window.confirm("Are you sure you want to cancel your subscription?")) {
      // Call the API to cancel the subscription
      dispatch(
        hitUpdateSubscriptionProfessionalApi({
          subscriptionId,
          isCancelled: 1,
          token: token,
        }),
      )
        .then((response) => {
          if (response.payload && response.payload.status === true) {
            showToast("Subscription cancelled successfully", "success");
            dispatch(hitGetSubscriptionProfessionalApi(token));
            // Update the state or redirect as needed
          } else {
            showToast("Failed to cancel subscription", "error");
          }
        })
        .catch((error) => {
          console.error("Error cancelling subscription:", error);
          showToast("Error cancelling subscription", "error");
        });
    }
  };

  const closeAnnualUpgradeModal = () => {
    if (isUpgradingAnnual || annualUpgradeSucceeded) return;
    setShowAnnualUpgradeModal(false);
  };

  const confirmAnnualUpgrade = () => {
    if (isUpgradingAnnual || annualUpgradeSucceeded) return;

    setIsUpgradingAnnual(true);
    dispatch(
      hitUpdateSubscriptionProfessionalApi({
        priceId: yearlyPlanPriceId,
        oldSubscriptionId: activeSubscriptionId,
        token: token,
      }),
    )
      .then((response) => {
        if (response.payload && response.payload.status === true) {
          setAnnualUpgradeSucceeded(true);
          setIsUpgradingAnnual(false);
          window.setTimeout(() => {
            window.location.reload();
          }, 600);
          return;
        }

        setIsUpgradingAnnual(false);
        showToast("Failed to upgrade subscription", "error");
      })
      .catch((error) => {
        console.error("Error upgrading subscription:", error);
        setIsUpgradingAnnual(false);
        showToast("Error upgrading subscription", "error");
      });
  };

  const upgradePlanDataYearly = {
    name: "Pro Plan+ Yearly",
    price: "1349",
    priceId: yearlyPlanPriceId,
  };

  const upgradeToProPlanMonthly = {
    name: "Pro Plan+ Monthly",
    price: "149",
    priceId: monthlyPlanPriceId,
  };

  const handleViewDetailTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const features = [
    {
      icon: <img src={pricing1} alt="Pricing 1" />,
      title: "100 Credits Per Month",
      description: "Use for bids, boosts, and much more.",
    },
    {
      icon: <img src={pricing2} alt="Pricing 2" />,
      title: "Top-Listed Pro Visibility",
      description: "Appear as a recommended professional in client searches.",
    },
    {
      icon: <img src={pricing3} alt="Pricing 3" />,
      title: "Exclusive Promotions",
      description: "Direct, non-competitive bids sent to you.",
    },
    {
      icon: <img src={pricing4} alt="Pricing 4" />,
      title: "Import Reviews",
      description: "Import your Google business reviews.",
    },
    {
      icon: <img src={pricing5} alt="Pricing 5" />,
      title: "Full Client Insights",
      description: "View past jobs, budget ranges, and total spends.",
    },
    {
      icon: <img src={pricing6} alt="Pricing 6" />,
      title: "Bid credit protection",
      description: "Credits refunded if the job posting is removed.",
    },
    {
      icon: <img src={pricing9} alt="Pricing 6" />,
      title: "See the number of bids on each job",
      description: "Track how many professionals have bid on each job.",
    },
    {
      icon: <img src={pricing7} alt="Pricing 7" />,
      title: "Ready-to-Go (RTG) Job Access",
      description: "Bid on high-intent clients ready to hire immediately.",
    },
    {
      icon: <img src={pricing8} alt="Pricing 7" />,
      title: "Good-Better-Best (GBB) Bid Options",
      description:
        "Offer tiered estimates for clearer, higher-converting proposals.",
    },
  ];

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="pricing-container pro-app-page manage-dashboard-screen mt-0"
      style={{ marginBottom: 0, minHeight: "auto" }}
    >
      <div
        className="custom_container"
        style={{ paddingTop: 0, marginBottom: 0 }}
      >
        <div className="plan-header pt-0">
          <h2 className="mt-0">Choose Your Perfect Plan</h2>
          <p className="subtext">
            Grow your renovation business and connect with quality clients
          </p>
          <div className="toggle-buttons">
            <div className="toggle-button-2"></div>
          </div>
        </div>

        <div className="plans">
          <Row>
            <Col md={12} lg={6} xl={4}>
              <div className="plan-card">
                {/* <div className="badge">Most Popular</div> */}

                <div className="plan-icon">
                  <img src={pricing_icon_profile} alt="pricing_icon_profile" />
                </div>
                <h3>Free Plan</h3>
                <div className="price">
                  $0<span>/month</span>
                </div>
                <p className="description">
                  Get started with basic features and purchase credits as you
                  go.
                </p>

                <div className="pro-plan-card-padding">
                  <div className="pro-plan-card">
                    <div className="card-header">
                      <h5>Free Plan:</h5>
                      {isOnFreePlan && (
                        <span className="status-badge">
                          <img src={activeIcon} alt="active" /> Active
                        </span>
                      )}
                    </div>

                    <ul className="features">
                      {/* <li>
                        <img src={Overlay_tick} alt="Overlay_tick" />
                        <div>
                          <span>
                            50 free credits on sign up (after business
                            verification)
                          </span>
                        </div>
                      </li> */}
                      <li>
                        <img src={Overlay_tick} alt="Overlay_tick" />
                        <div>
                          <span>
                            Purchase additional credits as needed
                            ($1/credit){" "}
                          </span>
                        </div>
                      </li>
                      <li>
                        <img src={Overlay_tick} alt="Overlay_tick" />
                        <div>
                          <span>Bid on any job using credits </span>
                        </div>
                      </li>
                      <li>
                        <img src={Overlay_tick} alt="Overlay_tick" />
                        <div>
                          <span>Standard profile visibility </span>
                        </div>
                      </li>
                      <li>
                        <img src={Overlay_tick} alt="Overlay_tick" />
                        <div>
                          <span>No client insights </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="card_footer">
                  {/* <button
                    className="cta-button cta-button-gray"
                    onClick={() => {
                      handleViewDetails();
                      navigate("/select-role", {
                        state: { clickBy: "Professional" },
                      });
                    }}
                  >
                    Get Started Free
                  </button> */}
                  <p className="guarantee">No credit card required</p>
                </div>
              </div>
            </Col>

            <Col md={12} lg={6} xl={4}>
              <div className="plan-card">
                <div className="badge">Most Popular</div>
                <div className="plan-icon">
                  <img src={Plan} alt="Plan" />
                </div>
                <h3>Pro Plan</h3>
                <div className="price">
                  $149<span>/month</span>
                </div>
                <p className="description">
                  Everything you need to grow your innovative business and
                  connect with quality clients
                </p>

                <div className="pro-plan-card-padding">
                  <div className="pro-plan-card">
                    <div className="card-header">
                      <h2 className="plan-title">Monthly Pro Plan</h2>
                      {isActiveMonthlyPlan ? (
                        <span className="status-badge">
                          <img src={activeIcon} alt="active" /> Active
                        </span>
                      ) : !isActiveYearlyPlan ? (
                        <button
                          className="cta-button cta-button-green"
                          style={{
                            marginLeft: 12,
                            background: "#10b981",
                            color: "#fff",
                            borderRadius: "12px",
                            border: "none",
                            fontWeight: 600,
                            padding: "0.3rem 0.75rem",
                            fontSize: "0.6875rem",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleSubscriptionWhenNoPlan("Pro Plan Monthly");
                          }}
                        >
                          UPGRADE
                        </button>
                      ) : null}
                    </div>

                    <div className="pricing">
                      <span className="price">$149</span>
                      <span className="period">/mo</span>
                    </div>

                    <div className="features-list">
                      {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                          <div
                            className="icon-wrapper"
                            style={{ backgroundColor: feature.color }}
                          >
                            {feature.icon}
                          </div>
                          <div className="feature-content">
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">
                              {feature.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* 
                <div className="card_footer">
                  <button
                    className="cta-button"
                    onClick={() => {
                      if (isActiveYearlyPlan === true || isOnFreePlan === true) {
                        handleSubscriptionWhenNoPlan("Pro Plan Monthly");
                       // handleViewDetails();
                      }
                    }}
                  >
                    {isActiveYearlyPlan === true ? "Downgrade To Monthly Plan - $149/mo" : isActiveMonthlyPlan === true ? "Activated Monthly Plan" : "Start Monthly Plan - $149/mo"}
                  </button>
                  <p className="guarantee">No setup fee • Cancel anytime</p>
                </div> */}
              </div>
            </Col>

            <Col md={12} lg={6} xl={4}>
              <div className="plan-card plan-card-green">
                <div className="badge badge-green">Best Value</div>
                <div className="plan-icon">
                  <img src={Annual} alt="Annual" />
                </div>
                <h3>Pro Plan Annual</h3>
                <div className="price">
                  $1,349<span>/year</span>
                </div>
                <p className="description">
                  Save $439 annually — get 3 months free plus 300 bonus credits!
                </p>

                <div className="pro-plan-card-padding">
                  <div className="pro-plan-card">
                    <div className="card-header">
                      <h2 className="plan-title">Annual Pro Plan</h2>
                      {isActiveYearlyPlan ? (
                        <span className="status-badge">
                          <img src={activeIcon} alt="active" /> Active
                        </span>
                      ) : isActiveMonthlyPlan ? (
                        <button
                          className="upgrade upgrade-green"
                          style={{
                            marginLeft: 12,
                            background: "#10b981",
                            color: "#fff",
                            borderRadius: "12px",
                            border: "none",
                            fontWeight: 600,
                            padding: "0.3rem 0.75rem",
                            fontSize: "0.6875rem",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setAnnualUpgradeSucceeded(false);
                            setShowAnnualUpgradeModal(true);
                          }}
                        >
                          UPGRADE
                        </button>
                      ) :
                        <button
                          className="upgrade upgrade-green"
                          style={{
                            marginLeft: 12,
                            background: "#10b981",
                            color: "#fff",
                            borderRadius: "12px",
                            border: "none",
                            fontWeight: 600,
                            padding: "0.3rem 0.75rem",
                            fontSize: "0.6875rem",
                            letterSpacing: "0.5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleSubscriptionWhenNoPlan("Pro Plan Annual");
                          }}
                        >
                          UPGRADE
                        </button>
                      }
                    </div>

                    <div className="pricing">
                      <span className="price">$1349</span>
                      <span className="period">/year</span>
                    </div>
                    <div className="features-list">
                      {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                          <div
                            className="icon-wrapper"
                            style={{ backgroundColor: feature.color }}
                          >
                            {feature.icon}
                          </div>
                          <div className="feature-content">
                            <h3 className="feature-title">{feature.title}</h3>
                            <p className="feature-description">
                              {feature.description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="feature-content annual-bonus">
                      <h3 className="feature-title">Annual Plan Bonus:</h3>
                      <p className="feature-description">
                        Save $439 Annually (3 months free + 300 bonus credits)
                      </p>
                    </div>
                  </div>
                </div>

                {/* <div className="card_footer card_footer_green">
                  <button
                    className="cta-button cta-button-green"
                    onClick={() => {

                      if (isActiveMonthlyPlan === true || isOnFreePlan === true) {
                        handleSubscriptionWhenNoPlan("Pro Plan Annual");
                        // handleViewDetails();
                      }
                    }}
                  >
                    {isActiveMonthlyPlan === true ? "Upgrade To Annual Plan - $1349/mo" : isActiveYearlyPlan === true ? "Activated Yearly Plan" : "Start Annual Plan - $1,349/yr"}
                  </button>
                  <p className="guarantee">No setup fee • Cancel anytime</p>
                </div> */}
              </div>
            </Col>
          </Row>
        </div>

        <div className="benefits">
          <Row>
            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={VerifiedClients} alt="VerifiedClients" />
                </div>
                <h6>Verified Clients</h6>
                <p>ID-verified homeowners. No spam, no fake leads.</p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={GrowYourBusiness} alt="GrowYourBusiness" />
                </div>
                <h6>Grow Your Business</h6>
                <p>
                  Everything you need to grow and win more jobs, right from your
                  desk.
                </p>
              </div>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <div className="benefit">
                <div className="icon">
                  <img src={ExpertSupport} alt="ExpertSupport" />
                </div>
                <h6>Expert Support</h6>
                <p>Get help whenever you need it from our support team.</p>
              </div>
            </Col>
          </Row>
        </div>

        {/* <div className="footer">
          <h4>Questions about pricing?</h4>
          <p>
            Our team is here to help you choose the right plan for your
            business.
          </p>
          <button
            className="contact-button"
            onClick={() => {
              handleViewDetails();
              navigate("/contacts-us");
            }}
          >
            Contact Sales
          </button>
        </div> */}
      </div>

      <Modal
        show={showAnnualUpgradeModal}
        onHide={closeAnnualUpgradeModal}
        centered
        className="annual-upgrade-modal"
      >
        <Modal.Body>
          {annualUpgradeSucceeded ? (
            <div className="annual-upgrade-modal__success">
              <span className="annual-upgrade-modal__success-icon">✓</span>
              <h3>You successfully upgraded</h3>
              <p>Your Annual Pro Plan is now active. Refreshing the page...</p>
            </div>
          ) : (
            <>
              <div className="annual-upgrade-modal__header">
                <span className="annual-upgrade-modal__badge">Best Value</span>
                <h3>Upgrade to Annual Pro Plan</h3>
                <p>
                  Confirm this upgrade to switch from Monthly Pro ($149/mo) to the
                  Annual Pro Plan.
                </p>
              </div>

              <div className="annual-upgrade-modal__price">
                <strong>$1,349</strong>
                <span>/year</span>
              </div>

              <ul className="annual-upgrade-modal__highlights">
                <li>Save $439 annually compared to monthly billing</li>
                <li>3 months free included in the annual price</li>
                <li>300 bonus credits added to your account</li>
                <li>All Monthly Pro Plan features included</li>
              </ul>

              <div className="annual-upgrade-modal__features">
                <h4>Plan specifications</h4>
                <ul>
                  {features.map((feature) => (
                    <li key={feature.title}>
                      <span>{feature.title}</span>
                      <small>{feature.description}</small>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="annual-upgrade-modal__actions">
                <button
                  type="button"
                  className="annual-upgrade-modal__cancel"
                  onClick={closeAnnualUpgradeModal}
                  disabled={isUpgradingAnnual}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="annual-upgrade-modal__confirm"
                  onClick={confirmAnnualUpgrade}
                  disabled={isUpgradingAnnual}
                >
                  {isUpgradingAnnual ? "Upgrading..." : "Confirm Upgrade"}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BuySubscription;
